import { render } from "./InviteLinkConfirmModal.vue?vue&type=template&id=62b6bf90&ts=true"
import script from "./InviteLinkConfirmModal.vue?vue&type=script&lang=ts"
export * from "./InviteLinkConfirmModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__